import { render, staticRenderFns } from "./promotion-company.vue?vue&type=template&id=f052baf6&scoped=true"
import script from "./promotion-company.vue?vue&type=script&lang=js"
export * from "./promotion-company.vue?vue&type=script&lang=js"
import style0 from "./promotion-company.vue?vue&type=style&index=0&id=f052baf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f052baf6",
  null
  
)

export default component.exports